import './styles.css';

export default [
  {
    title: 'Missing Inspection Date',
    dataIndex: 'missingInspectionDate',
    key: 'missingInspectionDate',
    sorter: true
  },
  {
    title: 'Day of week',
    dataIndex: 'dayOfWeek',
    key: 'dayOfWeek'
  },
  {
    title: 'Asset Name',
    dataIndex: 'assetName',
    key: 'assetName',
    sorter: true
  },
  {
    title: 'Asset Identification Number',
    dataIndex: 'salesforceAssetId',
    key: 'salesforceAssetId',
    sorter: true
  },
  {
    title: 'Asset Barcode Number',
    dataIndex: 'assetBarcode',
    key: 'assetBarcode',
    sorter: true
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    sorter: true
  },

  {
    title: 'Location',
    dataIndex: 'branchName',
    key: 'branchName',
    sorter: true
  }
];
